import { CustomEventCommand, CustomPlaceCommand } from '../../commands/hub/custom.event.command';

export class HubCustomBtn {
    public events: CustomEventCommand[];
    public places: CustomPlaceCommand[];
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/hub/hub.custom.btn.ts